import React from 'react';
import { styled } from '@elliemae/ds-system';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { Search } from '@elliemae/ds-icons';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Label = styled.p`
  color: ${(props) => props.theme.colors.neutral['600']};
  font-size: ${(props) => props.theme.space.xs};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`;

interface EmptyStateT {
  label: string;
  Icon: () => JSX.Element;
}

const DSMobileEmptyState: React.ComponentType<EmptyStateT> = ({ label = 'No search results found.', Icon }) => (
  <Wrapper>
    {Icon ? <Icon /> : <Search size="xxl" color={['neutral', 400]} />}
    <Label>{label}</Label>
  </Wrapper>
);

const props = {
  /** empty state label */
  label: PropTypes.string.description('empty state label'),
  icon: PropTypes.node.description('empty state icon'),
};

DSMobileEmptyState.displayName = 'DSMobileEmptyState';
const DSMobileEmptyStateWithSchema = describe(DSMobileEmptyState);
DSMobileEmptyStateWithSchema.propTypes = props;

export { DSMobileEmptyState, DSMobileEmptyStateWithSchema };
